




























import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Infos extends Vue {
  get appVersion (): string | undefined {
    return process.env.INFOS_APP_VERSION
  }
  get appVersionUrl (): string | undefined {
    return process.env.INFOS_APP_VERSION_URL
  }
  get gitVersion (): string | undefined {
    return process.env.INFOS_GIT_VERSION
  }
  get gitUrl (): string | undefined {
    return process.env.INFOS_GIT_VERSION_URL
  }
}
